import { render, staticRenderFns } from "./schedule-slots-form.vue?vue&type=template&id=9b62fed2&scoped=true&"
import script from "./schedule-slots-form.vue?vue&type=script&lang=ts&"
export * from "./schedule-slots-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b62fed2",
  null
  
)

export default component.exports